// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const Search = createIcon(
  <path
    clipRule="evenodd"
    d="M5.16816 10.3985C5.16816 7.51363 7.50021 5.17891 10.3721 5.17891C13.2439 5.17891 15.576 7.51363 15.576 10.3985C15.576 11.8058 15.0211 13.0821 14.1193 14.0204C14.1071 14.0313 14.0952 14.0427 14.0835 14.0544C14.0684 14.0695 14.054 14.0851 14.0402 14.101C13.0991 15.0389 11.8025 15.6182 10.3721 15.6182C7.50021 15.6182 5.16816 13.2834 5.16816 10.3985ZM14.6838 15.9307C13.4954 16.8626 11.9988 17.4182 10.3721 17.4182C6.50174 17.4182 3.36816 14.2732 3.36816 10.3985C3.36816 6.52388 6.50174 3.37891 10.3721 3.37891C14.2424 3.37891 17.376 6.52388 17.376 10.3985C17.376 11.9954 16.8437 13.4683 15.947 14.6483L20.369 19.0817C20.7201 19.4336 20.7201 20.0042 20.369 20.3561C20.018 20.708 19.4489 20.708 19.0979 20.3561L14.6838 15.9307Z"
    fillRule="evenodd"
  />,
);
